import React from 'react'
import {
	INITIALIZE_MAP_FROM_URL,
	UPDATE_MAP_STATE_ACTION,
	SAVE_RECALCULATED_FIELD_EXTENTS_ACTION,
	TOGGLE_BUTTON_TOGGLE_STATUS_ARRAY_FOR_FIELD_ACTION,
	TOGGLE_HAS_BEEN_EDITED_BY_THE_USER_PROP_ACTION,
	UPDATE_SELECTED_AND_COMPARISON_REGIONS_TO_NEW_GEOGRAPHY,
	SET_BUTTON_TOGGLE_STATUS_ARRAY_FOR_FIELD_ACTION,
	INITIAL_LOAD_OF_MAP_HAS_COMPLETED_ACTION, CLEAR_ALL_FILTERS_ACTION,
} from '../Actions/mapActions'
import {MAP_DEFAULT_SETTINGS} from "../../constants";

export const DEFAULT_FILTER_BOUNDS_OBJECT_PROPERTIES = {
	// filterBounds: [lowerBound, upperBound],
	hasBeenEditedByTheUser: false, // "changed" flag needed because geography switches can look like filter changes
	buttonToggleStatusArrayForField: [],
}

const MAP_DEFAULT_STATE = {
	// Constants
	settings: MAP_DEFAULT_SETTINGS,

	// Map UI booleans
	initialLoadOfMapHasCompleted: false,
	showStartScreen: false,
	storyMapMode: true,
	presenterModeActive: true,
	showSatelliteLayer: false,
	showPrimaryFilter: true,
	userHasDraggedToNewLocation: false,

	// Data-based filters and chloropleth visualization
	dynamicMapboxFilters: {
		fieldFilterBounds: {
			// [fieldNameForEachRespectiveFieldAvailable]: {
			// 	filterBounds: [lowerBound, upperBound],
			// 	hasBeenEditedByTheUser: bool, // "changed" flag triggered by manual edit button click
			//  buttonToggleStatusArrayForField: [],
			// }
			// ...
		},
		// Fetch and cache because calculating it is so expensive we want to do it as little as possible.
		fieldExtentsCache: {} //{"highed_lvl_4yr_2000up_blpct":[0,200], ...}
	},

	activeMapboxFilters: [],
	allMapboxFilters: [],

	// user control of hiding layers via advanced options
	userSetHideLayers: {},

	// Loaded/interactive
	clickedLayersInfo: null,
	hoveredLayersInfo: {
		// mouseHoverCoords,
		// hoveredCartoFeatures,
	},
	rawStorymap: null, // not loaded
	mapStyle: null, // not loaded
	defaultMapStyle: null, // not loaded
	selectedRegionInfo: {},
	comparisonRegionInfo: {},
	_isTransitioning: false,
	initialZoomInFromStartScreenComplete: false,
	_prev: { zoom: /*this.state.viewport ? this.state.viewport.zoom :*/ -1 },
	_turfManager: null,
	_mapRef: React.createRef(),
}

export default (state = MAP_DEFAULT_STATE, action) => {
	const {fieldFilterBounds} = state.dynamicMapboxFilters
	const {
		stateUpdates, recalculatedFieldExtents, fieldName,
		geoIdForSelectedRegion, buttonIndex, buttonIsActiveOnSceneStart,
	} = action
	
	switch (action.type) {
		case UPDATE_MAP_STATE_ACTION:
			return {
				...state,
				...stateUpdates,
			}
		case INITIALIZE_MAP_FROM_URL:
			return {
				...state,
				...stateUpdates,
			}
		case INITIAL_LOAD_OF_MAP_HAS_COMPLETED_ACTION:
			return {
				...state,
				initialLoadOfMapHasCompleted: true,
			}
		case SAVE_RECALCULATED_FIELD_EXTENTS_ACTION:
			return {
				...state,
				dynamicMapboxFilters: {
					...state.dynamicMapboxFilters,
					fieldExtentsCache: recalculatedFieldExtents,
				}
			}
		case TOGGLE_BUTTON_TOGGLE_STATUS_ARRAY_FOR_FIELD_ACTION:
			// NOTE: we're currently allowing at most one active button, hence false-ing all non-toggling buttons without question
			const _buttonToggleStatusArrayForField = fieldFilterBounds[fieldName].buttonToggleStatusArrayForField.map((isActive, index) => index === buttonIndex ? !isActive : false)
			return {
				...state,
				dynamicMapboxFilters: {
					...state.dynamicMapboxFilters,
					fieldFilterBounds: {
						...fieldFilterBounds,
						[fieldName]: {
							...fieldFilterBounds[fieldName],
							hasBeenEditedByTheUser: false,
							buttonToggleStatusArrayForField: _buttonToggleStatusArrayForField,
						}
						
					}
				}
			}
		case SET_BUTTON_TOGGLE_STATUS_ARRAY_FOR_FIELD_ACTION:
			return {
				...state,
				dynamicMapboxFilters: {
					...state.dynamicMapboxFilters,
					fieldFilterBounds: {
						...fieldFilterBounds,
						[fieldName]: {
							...fieldFilterBounds[fieldName],
							hasBeenEditedByTheUser: false,
							buttonToggleStatusArrayForField: buttonIsActiveOnSceneStart, // <-- direct seed from YAML
						}
						
					}
				}
			}
		case TOGGLE_HAS_BEEN_EDITED_BY_THE_USER_PROP_ACTION:
			return {
				...state,
				dynamicMapboxFilters: {
					...state.dynamicMapboxFilters,
					fieldFilterBounds: {
						...fieldFilterBounds,
						[fieldName]: {
							...fieldFilterBounds[fieldName],
							hasBeenEditedByTheUser: action.setHasBeenEditedToThisBoolValue === undefined ? !!!fieldFilterBounds[fieldName].hasBeenEditedByTheUser : action.setHasBeenEditedToThisBoolValue,
							buttonToggleStatusArrayForField: fieldFilterBounds[fieldName].buttonToggleStatusArrayForField.map(isActive => false),
						}
						
					}
				}
			}
		case CLEAR_ALL_FILTERS_ACTION:
			return {
				...state,
				dynamicMapboxFilters: {
					...state.dynamicMapboxFilters,
					fieldFilterBounds: Object.keys(fieldFilterBounds).reduce((_clearedFieldFilterBounds, currentFieldName) => (
						{
							..._clearedFieldFilterBounds,
							[currentFieldName]: {
								...fieldFilterBounds[currentFieldName],
								hasBeenEditedByTheUser: false,
								buttonToggleStatusArrayForField: fieldFilterBounds[currentFieldName].buttonToggleStatusArrayForField.map(isActive => false),
							}
						}
					), {})
				}
			}
		case UPDATE_SELECTED_AND_COMPARISON_REGIONS_TO_NEW_GEOGRAPHY:
			return {
				...state,
				selectedRegionInfo: {
					...state.selectedRegionInfo,
					geoIdForSelectedRegion,
				},
				comparisonRegionInfo: {}
			}
		default:
			return state
	}
}
